export const DAY_HEADER_PATTERN = /^(?:\*{1,2}|_{1,2})?\s*(?:Tag|Day)\s+[\d–\-]+/i;

export const stripMarkdown = value => value.replace(/\*\*|__/g, '').trim();

export const parseDayEntry = (detail, dayNumber, getTitleText, getDescriptionText) => {
  const explicitTitle = getTitleText(detail)?.trim();
  const rawText = getDescriptionText(detail)?.replace(/\\n/g, '\n').trim() || '';

  if (explicitTitle) {
    const plainTitle = stripMarkdown(explicitTitle);
    return {
      dayNumber,
      label: DAY_HEADER_PATTERN.test(plainTitle) ? plainTitle : null,
      titlePart: DAY_HEADER_PATTERN.test(plainTitle) ? null : plainTitle,
      text: rawText,
    };
  }

  if (!rawText) {
    return null;
  }

  const lines = rawText
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
  const firstLinePlain = stripMarkdown(lines[0]);

  if (DAY_HEADER_PATTERN.test(firstLinePlain)) {
    return {
      dayNumber,
      label: firstLinePlain,
      titlePart: null,
      text: lines.slice(1).join('\n\n').trim(),
    };
  }

  if (lines.length > 1) {
    return {
      dayNumber,
      label: null,
      titlePart: firstLinePlain,
      text: lines.slice(1).join('\n\n').trim(),
    };
  }

  return {
    dayNumber,
    label: null,
    titlePart: firstLinePlain,
    text: '',
  };
};

export const extractWeeklyPlanFromText = text => {
  if (!text?.trim()) {
    return { introText: '', days: [] };
  }

  const lines = text.replace(/\\n/g, '\n').split('\n');
  const introLines = [];
  const days = [];
  let currentDay = null;
  let foundFirstDay = false;

  const pushCurrentDay = () => {
    if (currentDay && (currentDay.label || currentDay.text)) {
      days.push({
        ...currentDay,
        dayNumber: days.length + 1,
        titlePart: null,
      });
    }
    currentDay = null;
  };

  lines.forEach(rawLine => {
    const line = rawLine.trim();

    if (!line) {
      if (currentDay?.text) {
        currentDay.text += '\n\n';
      } else if (!foundFirstDay) {
        introLines.push('');
      }
      return;
    }

    const plainLine = stripMarkdown(line);

    if (DAY_HEADER_PATTERN.test(plainLine)) {
      foundFirstDay = true;
      pushCurrentDay();
      currentDay = {
        label: plainLine,
        titlePart: null,
        text: '',
      };
      return;
    }

    if (currentDay) {
      currentDay.text = currentDay.text ? `${currentDay.text}\n\n${line}` : line;
    } else if (!foundFirstDay) {
      introLines.push(rawLine);
    }
  });

  pushCurrentDay();

  const introText = introLines
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  return { introText, days };
};

export const parseDaysFromActivitiesText = text => extractWeeklyPlanFromText(text).days;

export const hasDayItineraryInText = text => parseDaysFromActivitiesText(text).length > 0;

export const stripDayItineraryParagraphs = paragraphs => {
  const introText = extractWeeklyPlanFromText(paragraphs.join('\n\n')).introText;

  if (!introText) {
    return paragraphs.filter(paragraph => {
      const cleaned = stripMarkdown(paragraph.split('\n')[0]?.trim() || paragraph);
      return !DAY_HEADER_PATTERN.test(cleaned);
    });
  }

  return introText
    .split(/\n{2,}/)
    .map(paragraph => paragraph.trim())
    .filter(Boolean);
};
